import TransactionView from '../../components/TransactionView'
import { TransactionType } from '../../../../graphql'
import getColumns from 'views/reports/columns'
import { useFlags } from '@equipmentshare/feature-flags'

export default function IncomingPartsTransfers(): JSX.Element {
	const variables = { transactionTypes: TransactionType.StoreToStore }
	const flags = useFlags()
	const columns = getColumns( true, flags.enableTswWeightedAverageCost )

	return (
		<TransactionView
			title="Incoming Transfers"
			heaperPageTitle="Incoming Parts Transfers"
			variables={variables}
			storeIdsKey="toIds"
			columns={columns}
		/>
	)
}
